import { Component, OnInit } from "@angular/core";
import { JsLoaderService } from "src/shared/services/js-loader.service";

@Component({
  selector: "app-portal",
  templateUrl: "./portal.component.html"
})
export class PortalComponent implements OnInit {
  constructor(private jsLoader: JsLoaderService) {
    this.jsLoader.loadScripts();
  }

  ngOnInit() {}
}
